export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container">
        <p className="hero-eyebrow">Cloud · AI · Custom Solutions</p>
        <h1>
          Cloud and AI systems,
          <br />
          <span className="accent">built and operated.</span>
        </h1>
        <p className="lede">
          Viridian Cloud Partners builds and operates bespoke cloud and AI
          systems. AWS-certified engineers, grounded in your domain, and small
          enough that the people you meet in week one are the people in the
          pull requests in week four.
        </p>
        <div className="hero-actions">
          <a href="#contact" className="btn btn-primary btn-large">
            Get in touch
          </a>
          <a href="#services" className="btn btn-large">
            How we work
          </a>
        </div>
      </div>
    </section>
  );
}
